import React from 'react'
import { Container, Grow, Grid } from '@material-ui/core'
import { Button, Typography, Paper, FormControl } from '@material-ui/core'
//import Form from '../Form/Form'
import { Link } from 'react-router-dom'
import { URL } from '../../constants/actionTypes'
import FormViewListColor from '../Form/FormViewListColor'
import useStyles from './styles'
const ListColor = () => {
  const classes = useStyles()

  return (
    <Grow in style={{ backgroundColor: 'transparent' }}>
      <Container className='PageViewLogs'>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
          style={{ backgroundColor: 'transparent' }}
        >
          <Grid item xs={12} sm={12} style={{ backgroundColor: 'transparent' }}>
            <FormViewListColor />
          </Grid>
        </Grid>
      </Container>
    </Grow>
  )
}

export default ListColor
